export const DEFAULT_STAGES = [
  { key: "new", label: "New", probability: 10 },
  { key: "discovery", label: "Discovery", probability: 20 },
  { key: "solution_design", label: "Solution design", probability: 35 },
  { key: "calculation", label: "Calculation", probability: 50 },
  { key: "quote", label: "Quote", probability: 60 },
  { key: "negotiation", label: "Negotiation", probability: 80 },
  { key: "won", label: "Won", probability: 100 },
  { key: "lost", label: "Lost", probability: 0 },
];

export function stageLabel(key, stages = DEFAULT_STAGES) {
  return stages.find((s) => s.key === key)?.label || (key || "").replace(/_/g, " ").replace(/^\w/, (c) => c.toUpperCase());
}

export function stageColor(key) {
  return `hsl(var(--stage-${key || "new"}))`;
}

export const REQ_CATEGORIES = ["Purpose", "Studio", "Production", "Technical", "Software", "Delivery", "Commercial"];

export const LOST_REASONS = ["Price", "Competitor", "Technical fit", "Timing", "No decision", "Budget", "Other"];

export const ACTIVITY_ICONS = {
  created: "Plus",
  stage_change: "ArrowRight",
  requirement: "ListChecks",
  meeting: "Users",
  email: "Mail",
  quote_sent: "Send",
  quote_created: "FileText",
  solution: "Layers",
  tender: "FileSearch",
  note: "StickyNote",
  supplier_quote: "Truck",
  won: "Trophy",
  lost: "XCircle",
  file: "Paperclip",
  task: "CheckSquare",
  handover: "PackageCheck",
  approval: "BadgeCheck",
};
